import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Cartes de prestation de services',
  content: [
    'Les cartes de prestation de services, offertes dans certaines provinces, donnent accès aux services',
    'gouvernementaux. Il est donc important de les remplacer rapidement si elles ont été perdues ou volées. Suivez les',
    'étapes ci-dessous pour les remplacer :',

    '<h6>Colombie-Britannique</h6>',
    '<ul>',
    '<li>Si vous possédez une carte BC Services sans photo, signalez-en immédiatement la perte à Health Insurance BC au',
    '<a tabindex="0" href="tel:604-683-7151">604-683-7151</a> à Vancouver, et au <a tabindex="0" href="tel:+1-800-663-7100">1-800-663-7100</a>',
    'ailleurs en Colombie-Britannique. Health Insurance BC vous aidera à obtenir une nouvelle carte.</li>',
    '<li>Si vous possédez une carte de prestation de services de la C.-B. avec photo et que vous avez entre 19 et 75 ans',
    ', signalez-en la perte au <a tabindex="0" href="tel:250-978-8300">250-978-8300</a> si vous êtes à Victoria ou au',
    '<a tabindex="0" href="tel:+1-800-950-1498">1-800-950-1498</a> ailleurs en Colombie-Britannique. Vous pouvez obtenir votre nouvelle',
    'carte en visitant l&#39;un des bureaux d&#39;émission des permis de conduire de l&#39;Insurance Corporation of British Columbia',
    '(ICBC) le plus près de chez vous.</li>',
    '</ul>',

    '<h6>Territoires du Nord-Ouest</h6>',
    '<ul>',
    '<li>Communiquez avec le Bureau de l&#39;administration des services de santé à <a tabindex="0" href="mailto:healthcarecard@gov.nt.ca">',
    'healthcarecard@gov.nt.ca</a> ou en composant le <a tabindex="0" href="tel:+1-867-777-7400">1-867-777-7400</a> (Inuvik) ou le',
    '<a tabindex="0" href="tel:+1-800-661-0830">1-800-661-0830</a> (sans frais) pour demander une nouvelle carte.</li>',
    '</ul>',

    '<h6>Nunavut</h6>',
    '<ul>',
    '<li>Communiquez avec le Bureau des programmes d&#39;assurance santé  de Rankin Inlet à',
    'l&#39;adresse <a tabindex="0" href="mailto:nhip@gov.nu.ca">nhip@gov.nu.ca</a> ou en composant le <a tabindex="0" href="tel:+1-867-645-8001">',
    '1-867-645-8001</a> (Inuvik) ou le <a tabindex="0" href="tel:+1-800-661-0833">1-800-661-0833</a>',
    '(sans frais) pour demander une nouvelle carte.</li>',
    '</ul>',

    '<h6>Yukon</h6>',
    '<ul>',
    '<li>Communiquez avec les Services de santé assurés au <a tabindex="0" href="tel:+1-867-667-5209">1-867-667-5209</a>',
    'pour demander une nouvelle carte.</li>',
    '</ul>',
  ].join('\n')
};
